
define('text!views/wellness/partner/resource.html',[],function () { return '<a href="#">\r\n\t<span class="partner-resource-icon"><img src="<%- this.resource.logo %>" alt="<%- this.resource.link_text %>"></span> <%- this.resource.link_text %>\r\n</a>';});

